import axios from 'axios'
import { ENV_HELPERS } from '../constants'
import { TCreateDealerCompany, TDealerCompanies, TDealerCompaniesResponse, TDealerCompany, TDealerCompanyOption } from '@/types/v2/dealer-companies'
import { Response, TTableResponse } from '@/types/v2'

export const getDealerCompanies = async (queryString: string): Promise<TTableResponse<TDealerCompany>> => {
  const response = await axios.get<Response<TTableResponse<TDealerCompany>>>(
    `${ENV_HELPERS.apiUrl}/dealer_company?${queryString}`
  )
  const { data } = response.data
  return data
}

export const postCreateDealerCompany = async (
  body: TCreateDealerCompany
): Promise<Response<TCreateDealerCompany>> => {
  const { data: axiosData } = await axios.post<Response<TCreateDealerCompany>>(
    `${ENV_HELPERS.apiUrl}/dealer_company`,
    body
  )
  return axiosData
}
export const getDealerCompaniesSelect = async (): Promise<TDealerCompanyOption[]> => {
  const { data: axiosData } = await axios.get<Response<TDealerCompanyOption[]>>(
    `${ENV_HELPERS.apiUrl}/dealer_company/select`
  )
  return axiosData.data
}

export const getDealerCompaniesByManufacturer = async (id:string): Promise<TDealerCompanies[]> => {
  const { data: axiosData } = await axios.get<TDealerCompaniesResponse>(
    `${ENV_HELPERS.apiUrl}/manufacturer/${id}/companies`
  )
  return axiosData.message
}
